import { render, staticRenderFns } from "./ShowBranch.vue?vue&type=template&id=27826fd2&scoped=true&"
import script from "./ShowBranch.vue?vue&type=script&lang=ts&"
export * from "./ShowBranch.vue?vue&type=script&lang=ts&"
import style0 from "./ShowBranch.vue?vue&type=style&index=0&id=27826fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27826fd2",
  null
  
)

export default component.exports